document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("groupForm");
  if (!form) return; // ✅ only run if groupForm is present

  document.addEventListener("show.bs.modal", function (event) {
    const button = event.relatedTarget;
    const action = button.getAttribute("data-action");
    const form = document.getElementById("groupForm");

    if (action === "edit") {
      form.dataset.groupId = button.getAttribute("data-group-id");
      document.getElementById("group_name").value = button.getAttribute("data-group-name");
      document.getElementById("group_leader").value = button.getAttribute("data-group-leader-id");
    } else {
      form.dataset.groupId = "";
      form.reset();
    }
  });


  document.getElementById("saveGroupBtn").onclick = function () {
    const payload = {
      name: document.getElementById("group_name").value,
      leader_id: document.getElementById("group_leader").value
    };

    const form = document.getElementById("groupForm");
    const url = form.dataset.groupId ? `/groups/${form.dataset.groupId}` : "/groups";
    const method = form.dataset.groupId ? "PATCH" : "POST";

    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",   // ✅ important
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      },
      body: JSON.stringify({ group: payload })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        location.reload(); // or update DOM inline
      } else {
        alert(data.error || "An error occurred");
      }
    });
  };

});
